import { GenIcon, IconType } from 'react-icons/lib';

const UfpbFileError: IconType = (props: any) =>
  GenIcon({
    attr: {
      viewBox: '0 0 384 512',
    },
    child: [
      {
        attr: {
          d: 'M 48 0 C 21.49 0 0 21.49 0 48 L 0 252.13672 L 33.804688 285.94141 L 103.80469 215.94141 L 173.80469 285.94141 L 243.80469 215.94141 L 314.80469 286.94141 L 384 217.74805 L 384 160 L 256.90039 160 C 238.30039 160 224 145.7 224 128 L 224 0 L 48 0 z M 256 0 L 256 128 L 384 128 L 256 0 z M 103.80469 277.94141 L 33.804688 347.94141 L 0 314.13672 L 0 464 C 0 490.5 21.49 512 48 512 L 336 512 C 362.51 512 384 490.51 384 464 L 384 279.74805 L 315.62891 348.11719 L 314.80469 347.29297 L 313.98047 348.11719 L 243.80469 277.94141 L 173.80469 347.94141 L 103.80469 277.94141 z ',
        },
        child: [],
        tag: 'path',
      },
    ],
    tag: 'svg',
  })(props);

export default UfpbFileError;
